import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from "./features/auth/guard/auth.guard";
import { PageNotFoundComponent } from "./shared/components/page-not-found/page-not-found.component";
import { MainLayoutComponent } from "./shared/layouts/main-layout/main-layout.component";
import { SubLayoutComponent } from "./shared/layouts/sub-layout/sub-layout.component";
import { PolicyComponent } from "./shared/components/pages-footer/policy/policy.component";
import {DisputeResolutionComponent} from "./features/policy/pages/dispute-resolution/dispute-resolution.component";
import {InfoPrivacyPolicyComponent} from "./features/policy/pages/info-privacy-policy/info-privacy-policy.component";
import {RegistrationPolicyComponent} from "./features/policy/pages/registration-policy/registration-policy.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "affiliate",
    pathMatch: "full"
  },
  {
    path: "auth",
    component: SubLayoutComponent,
    loadChildren: () =>
      import("./features/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "profiles",
    component: MainLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import("./features/profile/profile.module").then((m) => m.ProfileModule),
  },
  {
    path: "affiliate",
    component: MainLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import("./features/affiliate/affiliate.module").then((m) => m.AffiliateModule),
  },
  {
    path: "chinh-sach",
    component: MainLayoutComponent,
    children: [
      {
        path: 'RegistrationPolicy',
        component: RegistrationPolicyComponent,
        title: "Chính sách đăng ký | 11N02"
      },
      {
        path: 'INFOPRIVACYPOLICY',
        component: InfoPrivacyPolicyComponent,
        title: "Chính sách bảo mật thông tin | 11N02"
      },
      {
        path: 'DISPUTERESOLUTION',
        component: DisputeResolutionComponent,
        title: "Giải quyết tranh chấp | 11N02"
      },
      {
        path: ":slug",
        component: PolicyComponent,
      }
    ],
  },
  {
    path: "recover/reset-password",
    redirectTo: "/auth/reset-password",
    pathMatch: "full",
  },
  {
    path: "go/:code",
    canActivate: [(route: import('@angular/router').ActivatedRouteSnapshot) => {
      const code = route.paramMap.get('code');
      import('../environments/environment').then(env => {
        // Prepend apiURL for local dev. In prod it will be '' and hit NGINX /api
        window.location.href = env.environment.apiURL + '/api/go/' + code;
      });
      return false;
    }],
    children: []
  },
  {
    path: "**",
    component: PageNotFoundComponent,
    title: "Không tìm thấy trang | 11N02"
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
